import Status from "../api/v2/Status.js";

export default class UtilResponse {

    static STATUS = Status;

    static getStatus = (response = {}) => {

        return response?.status;

    }

    static isStatus = (response = {}, statusCode = null) => {

        return this.getStatus(response) === statusCode;

    }

    static isOk = (response = {}, statusCode = 200) => {

        return this.isStatus(response, statusCode);

    }

    static isNotOk = (response = {}, statusCode = 200) => {

        return !this.isOk(response, statusCode);

    }

    static isCreated = (response = {}) => {

        return this.isStatus(response, this.STATUS.CREATED);

    }

    static isNoContent = (response = {}) => {

        return this.isStatus(response, this.STATUS.NO_CONTENT);

    }

    static isBadRequest = (response = {}) => {

        return this.isStatus(response, this.STATUS.BAD_REQUEST);

    }

    static isUnauthorized = (response = {}) => {

        return this.isStatus(response, this.STATUS.UNAUTHORIZED);

    }

    static isForbidden = (response = {}) => {

        return this.isStatus(response, this.STATUS.FORBIDDEN);

    }

    static isNotFound = (response = {}) => {

        return this.isStatus(response, this.STATUS.NOT_FOUND);

    }

    static isTimeout = (response = {}) => {

        return this.isStatus(response, this.STATUS.REQUEST_TIMEOUT);

    }

    static isInternalError = (response = {}) => {

        return this.isStatus(response, this.STATUS.INTERNAL_SERVER_ERROR);

    }

    static isTeapot = (response = {}) => {

        return this.isStatus(response, this.STATUS.IM_A_TEAPOT);

    }

    static isFetchError = (response = {}) => {

        const status = this.getStatus(response);

        return status === undefined || status === null || status === 0;

    }

    static isClientError = (response = {}) => {

        const status = this.getStatus(response);

        return status >= 400 && status <= 499;

    }

    static isServerError = (response = {}) => {

        const status = this.getStatus(response);

        return status >= 500 && status <= 599;

    }

    static isError = (response = {}) => {

        return this.isClientError(response) || this.isServerError(response) || this.isFetchError(response);

    }

}
